import { render, staticRenderFns } from "./invoicetermfrm.vue?vue&type=template&id=140efdc6"
import script from "./invoicetermfrm.vue?vue&type=script&lang=js"
export * from "./invoicetermfrm.vue?vue&type=script&lang=js"
import style0 from "./invoicetermfrm.vue?vue&type=style&index=0&id=140efdc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports